<template>
    <div class="subscribe-area bg-eee8df ptb-70">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="subscribe-image">
                        <img src="../../assets/img/subscribe/subscribe-img3.png" alt="image">
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="subscribe-content text-start" v-for="title of titles" :key="title.title_id">
                        <h2 class="font-weight-black">{{ title.title_header }}</h2>
                        <p>{{ title.title_content }}</p>
                        <form class="newsletter-form">
                            <input type="text" class="input-newsletter" placeholder="ör: 5315452814" name="phone">
                            <button type="submit" class="default-btn"><i class="flaticon-user"></i>{{ title.title_button
                            }}<span></span></button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="kindergarten-shape19">
            <img src="../../assets/img/kindergarten-shape/k-shape19.png" alt="image">
        </div>
        <div class="kindergarten-shape20">
            <img src="../../assets/img/kindergarten-shape/k-shape20.png" alt="image">
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: 'Subscribe',
    props: ['pathUrl'],

    created() {
        this.getTitles();
    },
    data() {
        return {
            titles: [],
            errors: []
        };
    },
    methods: {
        getTitles() {
            axios
                .get(this.pathUrl + "?data=title&parent=10")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        }
    }
}
</script>